// Build-time feature flags. Vite inlines `import.meta.env.VITE_*` at build,
// so flipping a flag requires a rebuild (which is what we want for a static
// SPA — the bundle decides whether portal CTAs are visible).
//
// Flag conventions:
//   - Default value = SAFE FOR PUBLIC LAUNCH (i.e. don't expose half-built
//     work). To enable in dev: `VITE_PORTAL_ENABLED=true` in .env.local.
//   - For prod: pass `--build-arg VITE_PORTAL_ENABLED=true` to docker build
//     (or set the corresponding Azure variable group key) when ready.

function flag(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined) return fallback;
  return value === 'true' || value === '1';
}

export const PORTAL_ENABLED = flag(import.meta.env.VITE_PORTAL_ENABLED, false);
